import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-secure_check",
  "use": "icon-secure_check-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 48 48\" id=\"icon-secure_check\">\n<path d=\"M3.8,5.8c11.2,0,17.7-3.2,20.2-5c2.6,1.8,9,5,20.2,5v21.9c0,3.4,0,12.4-20.2,19.4c-20.2-7-20.2-16-20.2-19.4L3.8,5.8\n\tL3.8,5.8z M20.1,26.9l-7-6.8c-0.3-0.3-0.8-0.5-1.3-0.4c-0.5,0.1-0.8,2.4-0.9,2.9c-0.1,0.5,0,1,0.4,1.3l7.9,7.7\n\tc0.5,0.5,1.3,0.5,1.8,0l14.3-14c0.5-0.5,0.5-1.3,0-1.9c-0.5-0.5-1.3-2.4-1.9-1.9L20.1,26.9z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol